export interface CapitalizeOptions {
  /** Capitalize the first letter of every word instead of just the first. */
  eachWord?: boolean;
}

/**
 * Capitalizes the first letter (or the first letter of each word with
 * `eachWord`). Leaves the rest of each word untouched. Returns '' for
 * null/undefined/empty input.
 * @registry Null-safe string capitalization (first letter or title case via eachWord).
 */
export const capitalize = (
  value?: string | null,
  options: CapitalizeOptions = {},
): string => {
  if (!value) return '';
  if (options.eachWord) {
    return value.replace(/\b\w/g, (c) => c.toUpperCase());
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export interface ServiceJobLabelParts {
  /** Service call id; service jobs share job number "0", so this acts as the job number. */
  jobNumber?: string | null;
  /** Service work order location (GP Adrscode). */
  address?: string | null;
  /** Service work order description. */
  jobName?: string | null;
}

/**
 * Formats a service job as `JOB NUMBER - ADDRESS - JOB NAME`. Blank parts drop
 * out, so the label never has an empty separator.
 * @registry Service job label (call id - location - description) for the service work-order picker and timesheet charge code cells.
 */
export const formatServiceJobLabel = ({
  jobNumber,
  address,
  jobName,
}: ServiceJobLabelParts): string =>
  [jobNumber, address, jobName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' - ');
